/* eslint-env browser */
/* eslint-disable */
if (!Object.entries) {
  Object.entries = obj => {
    const ownProps = Object.keys(obj);
    let i = ownProps.length;
    const resArray = new Array(i);

    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }

    return resArray;
  };
}
/* eslint-enable */

const Map = require("es6-map");
const DEV = window.promo.__env === "beta";

const userFrontEnd = Object.freeze({
  "bwin.com": "bz",
  "bwin.be": "bb",
  "bwin.es": "be",
  "bwin.it": "bi",
  "sh.bwin.de": "sh",
  "premium.com": "pr",
  "10premium.com": "pr",
  "premium39.com": "pr",
  "bwin.dk": "bd",
  "bwin.gr": "br",
  "bwin.fr": "bf",
  "partycasino.com": "pp",
  "partycasino.es": "pe",
  "partypremium.com": "pa",
  default: "nolabel"
});

const userFrontEndMap = new Map(Object.entries(userFrontEnd));

const userContextDesktop =
  window.bwin.config == null ? null : window.bwin.config.promoConfig;
const userContextMobile =
  window.clientConfig == null ? null : window.clientConfig.promoConfig;
const userInfoDesktop =
  window.bwin.config == null ? null : window.bwin.config.userInfo;
const userInfoMobile = window.clientConfig;

const userContext = () => {
  if (userContextDesktop) return userContextDesktop;
  if (userContextMobile) return userContextMobile;
  return {};
};

const userInfoContext = () => {
  if (userInfoDesktop) return userInfoDesktop;
  if (userInfoMobile) {
    return {
      // Sso: userInfoMobile.m2ClaimsConfig["http://api.bwin.com/v3/user/ssotoken"]
      Sso: userInfoMobile.vnClaims["http://api.bwin.com/v3/user/ssotoken"]
    };
  }
  return {};
};

const userVars = Object.freeze({
  ...userContext(),
  ...userInfoContext(),
  isNew: userContext.isKnown === false
});

/* eslint-disable no-underscore-dangle */
const scLangCode = () => {
  return window.__region === undefined
    ? window.promo.lang
    : `${window.promo.lang}_${window.__region}`;
};
/* eslint-enable no-underscore-dangle */

const sitecoreVars = Object.freeze({
  lang: window.promo.lang,
  portal: window.promo.portal,
  sso: window.promo.userSSO,
  langCode: scLangCode(),
  labelFK: null,
  targetGroupID: window.promo.targetGroupID,
  bonusID: window.promo.bonus_promotion_gid,
  isMobile: window.promo.isMobile === "True",
  isNative: window.promo.isNative === "True",
  loggedIn: window.promo.loggedIn
});

const envConfig = Object.freeze({
  dev: {
    host_local: "//e40d0626.ngrok.io", 
    host: "//mkp.itsfogo.com/sites/pc/promo/heads-or-tails",
    api: "//beta-api-mk.itsfogo.com/api"
  },
  prod: { 
    // host: "//mkp.itsfogo.com/sites/pc/promo/coin-flip/",
    host: "//mkp.itsfogo.com/sites/pc/promo/heads-or-tails",
    api: "//api-mk.itsfogo.com/api"
  }
});

const getCtaUrl = (state, data) => {
  if (!data) return "";

  if (state.isNative === true) { 
    return data.cta_url_native;
  } else if (state.isMobile === true) {
    // cta_url_mobile is generated based on desktop link - just switching smart part to mobile. This is not good enough for
    // vistabet as mobile launch game link there are just different than for desktop.
    if (data.cta_url_mobile.indexOf("vistabet") > -1) {
      return data.cta_url_native;
    } else {
      return data.cta_url_mobile;
    }
  } else {
    return data.cta_url_desktop;
  }
};

const helpers = Object.freeze({
  user: userVars,
  sitecore: sitecoreVars,
  config: DEV ? envConfig.dev : envConfig.prod,
  feGet: userFrontEndMap,
  getCtaUrl: getCtaUrl
});

export default helpers;



// WEBPACK FOOTER //
// ./app/js/helpers/globals.js